import { defineStore } from "pinia";

export const useTabStore = defineStore("tab", {
  state: () => ({
    editableTabsValue: "/index", // 当前激活的标签页
    editableTabs: [
      {
        title: "首页",
        name: "/index",
        closable: false,
      },
    ],
    tabStates: new Map(), // 存储每个标签页的状态（如表单数据）
  }),
  actions: {
    // 添加标签页
    addTabs(tab) {
      const tabIndex = this.editableTabs.findIndex((e) => e.name === tab.path);
      if (tabIndex === -1) {
        this.editableTabs.push({
          title: tab.name,
          name: tab.path,
          closable: true,
        });
        // 初始化标签页状态
        this.tabStates.set(tab.path, {
          formData: {}, // 表单数据
          tableData: [], // 列表数据
        });
      }
      this.editableTabsValue = tab.path;
    },
    // 重置标签页
    resetTabs() {
      this.editableTabsValue = "/index";
      this.editableTabs = [
        {
          title: "首页",
          name: "/index",
          closable: false,
        },
      ];
      this.tabStates.clear(); // 清空所有标签页状态
    },
    // 更新标签页状态
    updateTabState(tabPath, state) {
      if (this.tabStates.has(tabPath)) {
        this.tabStates.set(tabPath, {
          ...this.tabStates.get(tabPath),
          ...state,
        });
      }
    },
    // 获取标签页状态
    getTabState(tabPath) {
      return this.tabStates.get(tabPath) || { formData: {}, listData: [] };
    },
  },
});
